<template lang="pug">
#rastreabilidade-raizen
    BaseHeaderRastreabilidade(
        titulo='Nota De Pesagem',
        :voltarPara='voltarPara',
        icon='el-icon-plus',
        btnTexto='Inserir Documentos',
    )
    .view-container-base-header
        FiltroRastreabilidade(
            textoPlaceHolder='Pesquisa inteligente (Busque pela nota de pesagem  ou fazenda)'
            @atualizar-filtro='atualizarFiltro'
        )
        
        .container-totalizadores
            h2 Total de notas de pesagem cadastradas
            .totalizadores-lista
                div(v-for="item in this.dadosTotalizadores")
                    BaseCardTotalizadorRastreabilidade(
                        etapa='Notas de pesagem'
                        :texto='item.descricaoTotalizador',
                        :numero='item.totalNotaPesagemCadastrado',
                        :data='item.ultimaAtualizacaoNotaPesagemCadastrado'
                        icone='pesagem'
                    )

        BotoesDeAcoesRastreabilidade(
            btnPlaceHolder='Inserir Nota de Pesagem'
            @btnInserirClicado='openModalArquivo'
            @btnBaixarModeloClicado='baixarModeloArquivo'
        )
      
        TabelaNotaDePesagem(
            v-loading='buscandoNotaDePesagem',
            :dadosTabela='dadosTabela',
            :paginacao='paginacao',
            @atualizar-pagina='atualizarPagina',
            @atualizar-tabela='buscarNotaDePesagem'
        )
        ModalInsercaoArquivoNotaDePesagem(
            :show.sync='showModalArquivo'
            @sucessoUpload='atualizarDadosTela'
            @closeModal='closeModalArquivo'
        )
</template>
    
    <script>
    import BaseHeaderRastreabilidade from '@/components/rastreabilidadeRaizen/BaseHeaderRastreabilidade';
    import FiltroRastreabilidade from '@/components/rastreabilidadeRaizen/FiltroRastreabilidade';
    import TabelaNotaDePesagem from '@/components/rastreabilidadeRaizen/notaDePesagem/TabelaNotaDePesagem';
    import BotoesDeAcoesRastreabilidade from '@/components/rastreabilidadeRaizen/BotoesDeAcoesRastreabilidade';
    import BaseCardTotalizadorRastreabilidade from '@/components/rastreabilidadeRaizen/BaseCardTotalizadorRastreabilidade';

    import RastreabilidadeNotaDePesagemService from '@/services/RastreabilidadeNotaDePesagemService';
    import RastreabilidadeDocumentosService from '@/services/RastreabilidadeDocumentosService';

    import ModalInsercaoArquivoNotaDePesagem from '@/components/rastreabilidadeRaizen/notaDePesagem/ModalInsercaoArquivoNotaDePesagem';
    
    export default {
        name: 'NotaDePesagem',
        components: {
            BaseHeaderRastreabilidade,
            FiltroRastreabilidade,
            TabelaNotaDePesagem,
            ModalInsercaoArquivoNotaDePesagem,
            BotoesDeAcoesRastreabilidade,
            BaseCardTotalizadorRastreabilidade
        },
        data() {
            return {
                showModalArquivo: false,
                nomeColumn: null,
                voltarPara: true,
                paginacao: {
                    direcao: null,
                    itensPorPagina: 20,
                    ordernarPor: null,
                    pagina: 0,
                    totalPaginas: 0,
                    total: 0
                },
                filtros: '',
                dadosTabela: [],

                dadosTotalizadores: [],
    
                buscandoNotaDePesagem: true
            };
        },
        created() {
            this.buscarNotaDePesagem(0);
            this.buscarTotalizadoresNotaDePesagem();
        },
        methods: {
            btnHeaderClicado: function () {},
    
            async buscarNotaDePesagem(pagina) {
                this.buscandoNotaDePesagem = true;
                this.paginacao.pagina = pagina;
                await RastreabilidadeNotaDePesagemService.buscar(
                    this.filtros,
                    this.paginacao
                ).then(({ data }) => {
                    this.dadosTabela = data.itens;
                    this.paginacao = data.paginacao;
                    this.paginacao.pagina += 1;
                    this.buscandoNotaDePesagem = false;
                });

            },

            async buscarTotalizadoresNotaDePesagem() {
                const { data } =
                    await RastreabilidadeNotaDePesagemService.buscarTotalizadoresNotaDePesagem();
                this.dadosTotalizadores = data;
            },
    
            atualizarFiltro(dados) {
                this.filtros = dados;
                this.buscarNotaDePesagem(0);
            },
    
            atualizarPagina(pagina) {
                this.buscarNotaDePesagem(pagina);
            },

            openModalArquivo() {
                this.showModalArquivo = true;
            },

            closeModalArquivo() {
                this.showModalArquivo = false;
            },

            atualizarDadosTela() {
                this.buscarNotaDePesagem(0);
                this.buscarTotalizadoresNotaDePesagem();
            },

            ordenar(props) {
                this.paginacao.direcao = props.order;
                this.paginacao.ordernarPor = props.column.label;

                if (props.order === null) this.paginacao.ordernarPor = null;
                this.buscarNotaDePesagem(0);
            },
            
            async baixarModeloArquivo() {
                    await RastreabilidadeDocumentosService.baixarModeloCsv('NOTA_PESAGEM');
            }
        }
    };
    </script>
    <style lang="scss" scoped>
    #rastreabilidade-raizen {
        .box-instrucao {
            float: left;
            height: 39px;
            margin-right: 14px;
            color: #3b3b3b;
            max-width: 269px;
            font-size: 13px;
    
            span {
                padding-left: 3px;
                color: #1989fa;
                text-decoration-line: underline;
            }
        }

        .container-totalizadores {
            padding: 20px 35px 0px 20px;

            h2 {
                margin-bottom: 10px;
                margin-top: 10px;
                color: var(--black);
                font-weight: bold;
            }
            .totalizadores-lista {
                width: 100%;
                height: 99px;
                margin: 0 auto;
                display: grid;
                gap: 12px;
                grid-template-columns: 33% 33% 33%;
            }

            .totalizadores-bloco {
                width: 32%;
            }
        }
    }
    </style>
